// @flow
import { Route } from "react-router-dom";
import { AuthCheck } from "reactfire";
import React from "react";
import Login from "../pages/Login";

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        <AuthCheck
          fallback={
            <Login />
          }
        >
          {children}
        </AuthCheck>
      )}
    />
  );
}

export default PrivateRoute;
